import { GetNotesByAsset } from "../../../../common/components/notes/hooks/state/NoteSource";
import { useGetNotesByAssets } from "../../../../common/data/data-hooks/useGetNotesByAssets";
import { AssetType } from "../../../../common/types/AssetType";
import { DraftAssetType } from "../../../../common/types/DraftAssetType";
import { OrderAssetAvailability } from "../../../common/types/OrderAssetAvailability";
import { OrderAssetStorageType } from "../../../common/types/OrderAssetStorageType";
import { OrderDashboardItem } from "../OrderDashboardItem";

const prepareAssets = ({ cloudOrder }: { cloudOrder?: OrderDashboardItem }): GetNotesByAsset[] => {
    const assets: GetNotesByAsset[] = [];

    if (!cloudOrder) {
        return [];
    }

    if (cloudOrder.cloudAssets.video.assetId) {
        assets.push(
            getNotesByAssetParams({
                id: cloudOrder.cloudAssets.video.assetId,
                availability: cloudOrder.cloudAssets.video.availability,
                storageType: cloudOrder.cloudAssets.video.storageType
            })
        );
    }

    if (cloudOrder.cloudAssets.soundtracks.length) {
        cloudOrder.cloudAssets.soundtracks.forEach((soundtrack) => {
            if (soundtrack.assetId) {
                assets.push(
                    getNotesByAssetParams({
                        id: soundtrack.assetId,
                        availability: soundtrack.availability,
                        storageType: soundtrack.storageType
                    })
                );
            }
        });
    }

    if (cloudOrder.cloudAssets.subtitles.length) {
        cloudOrder.cloudAssets.subtitles.forEach((subtitle) => {
            if (subtitle.assetId) {
                assets.push(
                    getNotesByAssetParams({
                        id: subtitle.assetId,
                        availability: subtitle.availability,
                        storageType: subtitle.storageType
                    })
                );
            }
        });
    }

    return assets;
};

export const useCloudOrderAssetNotes = ({ cloudOrder }: { cloudOrder?: OrderDashboardItem }) => {
    const assets = prepareAssets({ cloudOrder });
    const { data: notes, isLoading } = useGetNotesByAssets({ assets });

    return { notes, areNotesLoading: isLoading };
};

const getNotesByAssetParams = ({
    id,
    availability,
    storageType
}: {
    id: string;
    availability: OrderAssetAvailability;
    storageType?: OrderAssetStorageType;
}): GetNotesByAsset => {
    const result: GetNotesByAsset = { id };

    if (availability === OrderAssetAvailability.FullMatch) {
        result.assetType = storageType === OrderAssetStorageType.OnPrem ? AssetType.OnPrem : AssetType.Cloud;
    }

    if (availability === OrderAssetAvailability.PartialMatch) {
        result.draftAssetType =
            storageType === OrderAssetStorageType.OnPrem ? DraftAssetType.OnPrem : DraftAssetType.Cloud;
    }

    return result;
};
